import PropTypes from 'prop-types'
import React from 'react'

import { Wrapper, Line, DynamicImageStyled } from './styles'

const Swab = ({ path }) => {
  return (
    <Wrapper>
      <DynamicImageStyled
        image={`${path}tube_swab`}
        imageSizes={{
          xs: 83,
          md: 316,
        }}
        alt="tube swab"
        imageType="png"
      />
      <Line>
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          x="0px"
          y="0px"
          viewBox="0 0 158 584"
        >
          <path
            fill="none"
            stroke="#FFFFFF"
            d="M-136,218.9h95.5c9.9,0,18,8.1,18,18v102c0,9.9,8.1,18,18,18H91"
          />
        </svg>
      </Line>
    </Wrapper>
  )
}

Swab.propTypes = {
  path: PropTypes.string.isRequired,
}

export default Swab
